import React, { Component } from "react";
import t from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
// import LockIcon from "@material-ui/icons/LockOutlined";
import { ReactComponent as LockIcon } from "@app/assets/svgs/Lock.svg";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import SupportDetails from "@app/common/components/SupportDetails";
import { TextField } from "juno-shared-components";
import CommonButton from "@app/common/components/material_ui/Button";
import { withRouter } from "react-router-dom";

import { css } from "@emotion/react";
import StreamlineIconWrapper from "@app/common/components/StreamlineIconWrapper";
import { Trans } from "@lingui/macro";

const propTypes = {
  password: t.string,
  classes: t.object,
  errors: t.array,
  history: t.object,
};

const rootStyle = theme => css`
  .MuiPaper-rounded {
      border-radius: 16px;
  }
  .MuiAvatar-root{
    > span > svg > path{
      stroke: ${theme.colors.lightText};
    }
  }
  .h6{
    color: ${theme.colors.text.main};
    padding-bottom: 20px;
  }
  .reset-password-body{
    padding-top: 8px;
    padding-bottom: 32px;
  }
  .text-field-wrapper{
    .MuiFormControl-marginNormal {
      margin-bottom: 16px;
    }
  }
  .buttonWrapper{
    padding-bottom: 16px;
  }
`;
const styles = theme => ({
  main: {
    fontFamily: "Lexend",
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 488,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(0)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: "#F1F6FD",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(),
  },
  passwordBottom: {
    paddingBottom: `${theme.spacing(2)}px`,
  },
});

class PasswordComponent extends Component {
  constructor(props) {
    super(props);
    // AnalyticsUpdatePage("Forgot Password Page");
    this.email = React.createRef();
    this.username = React.createRef();
    this._handleSubmit = this._handleSubmit.bind(this);

    this.state = {
      resetDone: false,
      isError: false,
    };
  }

  _handleSubmit(e) {
    e.preventDefault();
    if (this.username?.current?.value.trim() === "") {
      return;
    }
    // sendActionAnalytics('Forgot-Password',`${this.email.current.value}`);
    this.props.password(this.username.current.value);
    this.setState({ resetDone: true });
  }

  onChange = (e) => {
    e.target.value.trim() === "" ? this.setState({ isError: true }) : this.setState({ isError: false });
  }
  
  render() {
    const { classes, errors } = this.props;
    const { resetDone, isError } = this.state;

    let ErrorMessage = null;

    if (errors) {
      ErrorMessage = errors.map((errorMessage, index) => (
        <div key={`e-${index + 1}`} style={{ color: "red", textAlign: "center" }}>
          {errorMessage}
        </div>
      ));
    }

    if (resetDone) {
      return (
        <main className={classes.main} css={rootStyle}>
          <CssBaseline />
          <Paper className={`${classes.paper}  ${classes.passwordBottom}`}>
            <Avatar className={classes.avatar}>
              <StreamlineIconWrapper><LockIcon /></StreamlineIconWrapper>
            </Avatar>
            {/* <Typography component="h1" variant="h5"> */}
            <div className="h6">
              <Trans>Reset Password</Trans>
            </div>
            {/* </Typography> */}
            <div className="body1 reset-password-body" style={{ paddingLeft: "24px", color: "#0F1140" }}>
              <Trans>We&apos;ve sent you a notification with instructions for resetting your password.</Trans>
            </div>
            {/* <Button onClick={() => this.setState({ resetDone: false })} fullWidth variant="contained" color="primary" className={classes.submit}>
              <Trans>dn't get the email? Click to get a new one.</Trans>
            </Button>
            <Button component={Link} to="/login" className={classes.button}>
              <KeyboardBackspaceIcon className={classes.leftIcon} />
              <Trans>og In</Trans>
            </Button> */}
          </Paper>
        </main>
      );
    }

    return (
      <main className={classes.main} css={rootStyle}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <StreamlineIconWrapper><LockIcon /></StreamlineIconWrapper>
          </Avatar>
          {/* <Typography component="h1" variant="h5"> */}
          <div className="h6">
            <Trans>Reset Your Password</Trans>
          </div>
          {/* </Typography> */}
          <form className={classes.form} onSubmit={this._handleSubmit}>
            <div className="body1" style={{ paddingLeft: "24px", color: "#0F1140" }}>
              <Trans>Enter your username below: You will receive a link to reset your password.</Trans>
            </div>
            <div className="text-field-wrapper">
              <FormControl margin="normal" required fullWidth>
                {/* <InputLabel htmlFor="username">
                <Trans>Username</Trans>
              </InputLabel>
              <Input id="username" inputRef={this.username} name="username" autoComplete="username" autoFocus /> */}
                <Trans render={(trans) => (
                  <TextField
                    placeholder={trans.translation}
                    id="username"
                    name="username"
                    autoFocus
                    autoComplete="username"
                    inputRef={this.username}
                    size="medium"
                    error={isError}
                    onChange={(e) => this.onChange(e)}
                  />
                )}
                >
                  Username
                </Trans>
                
              </FormControl>
            </div>
            {ErrorMessage}
            {/* <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
              <Trans>Send</Trans>
            </Button> */}
            <div className="buttonWrapper">
              <CommonButton
                type="submit"
                disabled={!this.username?.current || this.username.current.value.trim() === ""}
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                <Trans>Send</Trans>
              </CommonButton>
            </div>
            {/* <Button component={Link} to="/login" className={classes.button}>
              <KeyboardBackspaceIcon className={classes.leftIcon} />
              <Trans>Back to LogIn</Trans>
            </Button> */}
            <div className="buttonWrapper" style={{ paddingBottom: "74px" }}>
              <CommonButton
                fullWidth
                size="large"
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={() => { this.props?.errors && this.props.errors.pop(); this.props.history.push("/login"); }}
                to="/login"
              >
                <Trans>Back to login</Trans>
              </CommonButton>
            </div>
          </form>
          <SupportDetails className="login-support" showEmail={false} pageName="set password" />
        </Paper>
      </main>
    );
  }
}

PasswordComponent.propTypes = propTypes;

export default withRouter(withStyles(styles, { withTheme: true })(PasswordComponent));
